// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  width: 90%;
  margin: 15px auto;
}

.title {
  font-family: AppFontSemiBold, sans-serif;
  margin-top: 15px;
  font-size: 22px;
  text-align: center;
  text-transform: capitalize;
  color: var(--color-black);
}

ion-item {
  border: 1px solid #e5e5e5;
  border-radius: 0px;
  font-size: 16px !important;
  color: black;
  --background: white;
}
ion-item ion-label {
  margin-left: 10px;
  margin-right: 8px;
}

ion-icon {
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/app/components/add-custom-tip/add-custom-tip.component.scss"],"names":[],"mappings":"AAEA;EACC,UAAA;EACA,iBAAA;AADD;;AAGA;EACC,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,yBAAA;AAAD;;AAGA;EACC,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,YAAA;EACA,mBAAA;AAAD;AACC;EACC,iBAAA;EACA,iBAAA;AACF;;AAGA;EACC,WAAA;AAAD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n.wrapper {\n\twidth: 90%;\n\tmargin: 15px auto;\n}\n.title {\n\tfont-family: AppFontSemiBold, sans-serif;\n\tmargin-top: 15px;\n\tfont-size: 22px;\n\ttext-align: center;\n\ttext-transform: capitalize;\n\tcolor: var(--color-black);\n}\n\nion-item {\n\tborder: 1px solid #e5e5e5;\n\tborder-radius: 0px;\n\tfont-size: 16px !important;\n\tcolor: black;\n\t--background: white;\n\tion-label {\n\t\tmargin-left: 10px;\n\t\tmargin-right: 8px;\n\t}\n}\n\nion-icon {\n\tz-index: 10;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
